function global() {
  // brand global init (component custom-elements self-register via side-effect imports)
}

export default global;
